export const GlobalActionTypes = {
  ACTION_CHAIN: 'global|resolvingActionChain',
  SET_GLOBAL_ERROR: 'global|setGlobalError',
  CLEAR_GLOBAL_ERROR: 'global|clearGlobalError',
  GET_CERTIFIED_MODAL: {
    OPEN: 'global|getCertifiedModal:open',
    CLOSE: 'global|getCertifiedModal:close',
  },
  TRAINING_REQUIRED_MODAL: {
    OPEN: 'global|trainingRequiredModal:open',
    CLOSE: 'global|trainingRequiredModal:close',
  },
  SUBMIT_ORDER_MODAL: {
    // TODO: try come up with a better name
    TRY_OPEN: 'global|submitOrderModal:tryOpen',
    OPEN: 'global|submitOrderModal:open',
    CLOSE: 'global|submitOrderModal:close',
  },
  ACCEPT_LEADS_PASSING_MODAL: {
    // OPEN: 'global|acceptLeadsPassingModal:open',
    CLOSE: 'global|acceptLeadsPassingModal:close',
  },
};
